import { IFilterAllData, ListOfKeysFilterAllData } from 'src/typings/filter';
import { View2dType } from 'src/typings/view-2d';

export interface ISection {
  floorList: string[];
  sectionName: string;
  sectionData: IFilterAllData[];
}

export interface IFillFloorsData {
  [key: string]: (IFilterAllData | null)[];
}

interface IView2dTypeMapPropUnknown {
  type?: 'unknown'
}
interface IView2dTypeMapPropText {
  type?: 'text'
}
interface IView2dTypeMapPropNumber {
  type?: 'number'
  isPrice?: boolean,
  needToBeRounded?: boolean,
  needToBeShort?: boolean,
}
type IView2dTypeMapProp = IView2dTypeMapPropText | IView2dTypeMapPropNumber | IView2dTypeMapPropUnknown;
type IView2dTypeMap = {
  [key in View2dType]: IView2dTypeMapProp
}

export const View2dTypeMappingToPlacementType = {
  [View2dType.area]: ListOfKeysFilterAllData.placementTotalArea,
  [View2dType.rooms]: ListOfKeysFilterAllData.placementRooms,
  [View2dType.numeration]: ListOfKeysFilterAllData.placementNumeration,
  [View2dType.price]: ListOfKeysFilterAllData.placementTotalPrice,
  [View2dType.priceAlternative]: ListOfKeysFilterAllData.placementTotalPriceAlternative,
  [View2dType.pricePM]: ListOfKeysFilterAllData.placementPricePerSqM,
  [View2dType.pricePMAlternative]: ListOfKeysFilterAllData.placementPricePerSqMAlternative,
  [View2dType.row0]: ListOfKeysFilterAllData.row0,
  [View2dType.row1]: ListOfKeysFilterAllData.row1,
  [View2dType.row2]: ListOfKeysFilterAllData.row2,
  [View2dType.row3]: ListOfKeysFilterAllData.row3,
  [View2dType.row4]: ListOfKeysFilterAllData.row4,
  [View2dType.row5]: ListOfKeysFilterAllData.row5,
  [View2dType.row6]: ListOfKeysFilterAllData.row6,
  [View2dType.row7]: ListOfKeysFilterAllData.row7,
  [View2dType.row8]: ListOfKeysFilterAllData.row8,
  [View2dType.row9]: ListOfKeysFilterAllData.row9,
};

export const View2dTypeMap: IView2dTypeMap = {
  [View2dType.rooms]: {
    type: 'text',
  },
  [View2dType.area]: {
    type: 'number',
    isPrice: false,
    needToBeRounded: true,
    needToBeShort: false,
  },
  [View2dType.numeration]: {
    type: 'number',
    isPrice: false,
    needToBeRounded: false,
    needToBeShort: false,
  },
  [View2dType.price]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
  [View2dType.priceAlternative]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
  [View2dType.pricePM]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
  [View2dType.pricePMAlternative]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
  [View2dType.row0]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
  [View2dType.row1]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
  [View2dType.row2]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
  [View2dType.row3]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
  [View2dType.row4]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
  [View2dType.row5]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
  [View2dType.row6]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
  [View2dType.row7]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
  [View2dType.row8]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
  [View2dType.row9]: {
    type: 'number',
    isPrice: true,
    needToBeRounded: false,
    needToBeShort: true,
  },
};
